import React, { useState, useEffect } from "react";
import classNames from "classnames"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import UniversalLink from "§/src/utils/UniversalLink"
import { useStaticQuery, graphql } from "gatsby";

import "§/src/components/contact-modal/_contact-form.scss"
import CoutryList from "./countries.json"

import { useTranslation } from "react-i18next"
import { useForm } from "react-hook-form"

const useYupValidationResolver = (requestTypeValue, infoProdottoValue) =>
  yup.object({
    input_1: yup.string().required(), // nome
    input_2: yup.string().required(), // cognome
    input_3: yup.string().email().required(), // email
    input_4_3: yup.string().required(), // citta
    input_4_6: yup.string().required(), // paese
    input_6: yup.string().required(), // telefono
    input_7: yup.string().required(), // azienda
    input_8: yup.string(), // messaggio
    input_9_1: yup.boolean().equals([true]), // consent
    input_10: yup.string(),
    input_11: yup.string().required(), // tipo di richiesta
    input_12: yup.string().when("input_11", { // categoria prodotto
      is: infoProdottoValue,
      then: yup.string().required(),
      otherwise: yup.string(),
    }),
    input_13: yup.string(), // prodotto
    input_14: yup.string(), // titolo pagina
    input_15: yup.string(), // url pagina
  })
  .required()

const ContactFormFloating = props => {
  const { t } = useTranslation()

  // Request type handler
  const [selectedRequestType, setSelectedRequestType] = useState("");
  const infoProdottoValue = t("Info prodotto")
  const resolver = useYupValidationResolver(selectedRequestType, infoProdottoValue );

  const {
    reset,
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: 'onSubmit', // This will trigger validation only on submit
    resolver: yupResolver(resolver),
    defaultValues: {
      input_1: "",
      input_2: "",
      input_3: "",
      input_4_3: "",
      input_4_6: "",
      input_6: "",
      input_7: "",
      input_8: "",
      input_9_1: false,
      input_10: "",
      input_11: "",
      input_12: "",
      input_13: "",
      input_14: `${props.pageTitle}`,
      input_15: "",
    },
  })

  const formClass = fieldName => {
    return classNames("contact-form__form-row", {
      error: isError(fieldName),
    })
  }

  const isError = (fieldName, type) => {
    if (!type) {
      type = "required"
    }
    const error = !!errors && !!errors[fieldName]
    return error && errors[fieldName].type === type
  }

  const onSubmit = async data => {
    if (!!props.onSubmit) {
      await props.onSubmit(data)
      reset()
    } else {
      console.error(data)
      reset()
    }
  }

  // Terms and Privacy links
  const linkFormTerms = props?.formLinks?.globalFormLinks?.acfoptGlobalOptions?.acfGlobal?.termsAndConditionsLink
  const linkFormPrivacy = props?.formLinks?.globalFormLinks?.acfoptGlobalOptions?.acfGlobal?.privacyPolicyLink

  // Country list select fields
  const countries = CoutryList

  // Request type select fields
  const requestType = [
    `${t("Quotazione")}`,
    `${t("Info prodotto")}`,
    `${t("Supporto tecnico")}`,
    `${t("Altro")}`,
  ]

  // Categoies and his products object
  const catProductType = useStaticQuery(graphql`
    query allProductsAndCats {
      allWpProductCategory(
        filter: {parentId: {ne: "null"}, wpChildren: {nodes: {elemMatch: {isTermNode: {eq: true}}}}}
      ) {
        nodes {
          name
          products {
            nodes {
              title
            }
          }
        }
      }
    }
  `);

  // Selected category logic handler
  const [selectedCategory, setSelectedCategory] = useState('');
  const [products, setProducts] = useState([]);

  const handleCategoryChange = (event) => {
    const categoryName = event.target.value;
    setSelectedCategory(categoryName);
    const category = catProductType.allWpProductCategory.nodes.find(cat => cat.name === categoryName);
    setProducts(category ? category.products.nodes : []);
  };

  // Watch the value of request type
  const requestTypeValue = watch("input_11");
  useEffect(() => {
    if (requestTypeValue === infoProdottoValue) {
      // Set with no validation
      setValue('input_12', '', { shouldValidate: false });
    } else {
      // Reset the category and product values
      setSelectedCategory('');
      setProducts([]);
      setValue('input_12', '', { shouldValidate: false });
      setValue('input_product', '', { shouldValidate: false });
    }

    setValue("input_15", window.location.href, { shouldValidate: false })
  }, [requestTypeValue, setValue, infoProdottoValue]);


  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="mb-6">
        <div className={formClass("input_1")}>
          <label className="contact-form__label" htmlFor="input_1">
            {t("Nome")}*
          </label>
          <input
            className="contact-form__input"
            type="text"
            id="input_1"
            {...register("input_1", { required: true })}
          />
        </div>
        {!!isError("input_1") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_2")}>
          <label className="contact-form__label" htmlFor="input_2">
            {t("Cognome")}*
          </label>
          <input
            className="contact-form__input"
            type="text"
            id="input_2"
            {...register("input_2", { required: true })}
          />
        </div>
        {!!isError("input_2") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_3")}>
          <label className="contact-form__label" htmlFor="input_3">
            {t("Email")}*
          </label>
          <input
            className="contact-form__input"
            type="email"
            id="input_3"
            {...register("input_3", { required: true })}
          />
        </div>
        {!!isError("input_3") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
        {!!isError("input_3", "email") && (
          <span className="contact-form__error-message">
            *{t("controllare formattazione mail")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_4_6")}>
          <label className="contact-form__label" htmlFor="input_4_6">
            {t("Stato")}*
          </label>

          <select
            {...register("input_4_6", { required: true })}
            id="input_4_6"
            className="contact-form__input select-input"
            onChange={function (e) {
              setValue("input_4_6", e.target.value, { shouldValidate: true })
              setValue("input_10", e.target.value, { shouldValidate: true })
            }} // Using setValue
          >
            <option key="placeholder" value="">
              {t("Seleziona")}
            </option>
            {countries.map((country, index) => {
              return (
                <option key={index} value={country}>
                  {country}
                </option>
              )
            })}
          </select>
        </div>
        {!!isError("input_4_6") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_4_3")}>
          <label className="contact-form__label" htmlFor="input_4_3">
            {t("Citta")}*
          </label>
          <input
            className="contact-form__input"
            id="input_4_3"
            {...register("input_4_3", { required: true })}
          />
        </div>
        {!!isError("input_4_3") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_6")}>
          <label className="contact-form__label" htmlFor="input_6">
            {t("Telefono")}*
          </label>
          <input
            className="contact-form__input"
            type="tel"
            id="input_6"
            {...register("input_6", { required: true })}
          />
        </div>
        {!!isError("input_6") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_7")}>
          <label className="contact-form__label" htmlFor="input_7">
            {t("Nome azienda")}*
          </label>
          <input
            className="contact-form__input"
            type="tel"
            id="input_7"
            {...register("input_7", { required: true })}
          />
        </div>
        {!!isError("input_7") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className="mb-6">
        <div className={formClass("input_11")}>
          <label className="contact-form__label" htmlFor="input_11">
            {t("Tipo di richiesta")}*
          </label>

          <select
            {...register("input_11", { required: true })}
            id="input_11"
            className="contact-form__input select-input"
            onChange={function (e) {
              setValue("input_11", e.target.value, { shouldValidate: true })
            }} // Using setValue
          >
            <option key="placeholder" value="">
              {t("Seleziona")}
            </option>
            {requestType.map((request, index) => {
              return (
                <option key={index} value={request}>
                  {request}
                </option>
              )
            })}
          </select>
        </div>
        {!!isError("input_11") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className={`mb-6 prod-cat ${requestTypeValue === t("Info prodotto") ? "" : "d-none"}`}>
        <div className={formClass("input_12")}>
          <label className="contact-form__label" htmlFor="input_12">
            {t("Categoria di prodotto")}*
          </label>

          <select
            {...register("input_12", { required: requestTypeValue === t("Info prodotto") })}
            id="input_12"
            className="contact-form__input select-input"
            onChange={function (e) {
              setValue("input_12", e.target.value, { shouldValidate: true })
              handleCategoryChange(e)
            }} // Using setValue
          >
            <option key="placeholder" value="">
              {t("Seleziona")}
            </option>
            {catProductType.allWpProductCategory.nodes.map((category, index) => (
              <option key={index} value={category.name}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        {!!isError("input_12") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <div className={`mb-6 ${selectedCategory ? "" : "d-none"}`}>
        <div className={formClass("input_13")}>
          <label className="contact-form__label" htmlFor="input_13">
            {t("Prodotto")}
          </label>
          <select
            {...register("input_13", { required: selectedCategory !== "" })}
            id="input_13"
            className="contact-form__input select-input"
          >
            <option key="placeholder" value="">
              {t("Seleziona")}
            </option>
            {products.map((product, index) => (
              <option key={index} value={product.title}>
                {product.title}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="mb-6">
        <div className="contact-form__form-col">
          <label className="contact-form__label" htmlFor="input_8">
            {t("Messaggio")}
          </label>
          <textarea
            className="contact-form__input w-100"
            rows="7"
            id="input_8"
            {...register("input_8")}
          ></textarea>
        </div>
      </div>
      <div className="mb-6">
        <div className="contact-form__checkbox-row">
          <input
            type="checkbox"
            className="contact-form__checkbox"
            id="input_9_1"
            {...register("input_9_1")}
          />
          <label
            className="flex-grow-1 terms-privacy-form-accept"
            htmlFor="input_9_1"
          >
            <UniversalLink to={linkFormTerms} className="ms-1 me-2">
              {linkFormTerms[2]}
            </UniversalLink>
            <UniversalLink to={linkFormPrivacy}>
              {linkFormPrivacy[2]}
            </UniversalLink>
          </label>
        </div>
        {!!isError("input_9_1", "oneOf") && (
          <span className="contact-form__error-message">
            *{t("Campo richiesto")}
          </span>
        )}
      </div>
      <input type="hidden" {...register("input_10")} />
      <input type="hidden" {...register("input_14")} />
      <input type="hidden" {...register("input_15")} />
      <div className="mb-80">
        <button
          type="submit"
          className="contact-form__submit"
          disabled={isSubmitting}
        >
          {t("Invia richiesta")}
        </button>
      </div>
    </form>
  )
}

export default ContactFormFloating
